const utilColors = {
  white: "#ffffff",
  oliveGreen: "#618833",
  bloodRed: "#b2102f",
  skyBlue: "#90caf9",
};

export default utilColors;
